(ns ui.typography
  (:require [ui.utils :refer [clsx separate-props]]))

(defn h1 [& args]
  (let [[props children] (separate-props args)]
    (into [:h1 (update props :class #(clsx "text-2xl leading-8 font-medium" %))]
          children)))

(defn h2 [& args]
  (let [[props children] (separate-props args)]
    (into [:h2 (update props :class #(clsx "text-xl leading-8 font-medium break-words" %))]
          children)))

(defn h3 [& args]
  (let [[props children] (separate-props args)]
    (into [:h3 (update props :class #(clsx "text-base font-medium" %))]
          children)))

(defn h4 [& args]
  (let [[props children] (separate-props args)]
    (into [:h4 (update props :class #(clsx "text-sm font-medium" %))]
          children)))

(defn h5 [& args]
  (let [[props children] (separate-props args)]
    (into [:h4 (update props :class #(clsx "text-xs font-medium" %))]
          children)))

(defn p [& args]
  (let [[props children] (separate-props args)]
    (into [:p (update props :class #(clsx "text-sm" %))]
          children)))

(defn small [& args]
  (let [[props children] (separate-props args)]
    (into [:small (update props :class #(clsx "text-xs" %))]
          children)))

(defn label [& args]
  (let [[props children] (separate-props args)]
    (into [:label (update props :class #(clsx "text-sm font-medium" %))]
          children)))

(defn- typography-variant
  [variant]
  (case variant
    :h1 h1
    :h2 h2
    :h3 h3
    :h4 h4
    :p  p
    :small small
    :label label
    (js/console.error "Unknown typography variant")))

(defn typography [{:keys [variant class] :as props} & children]
  (let [component (typography-variant (or variant :p))
        props (-> props
                  (dissoc :variant)
                  (assoc :class class))]
    (into [component props] children)))
